import { Component, Input } from '@angular/core';
import { PersonStammMasterDetailEntryMeta } from '../../../../core/personstamm-api';
import { LinkComponent, NavTarget } from '../../../components/link/link.component';
import { ListLoaderPreloaded } from 'app/shared/components/list-loader/list-loader-preloaded';
import { AbstractComponent } from 'app/shared/components/abstract-component/abstract.component';
import { ListLoader } from 'app/shared/components/list-loader/list-loader';
import { BeschreibungTableWrapperComponent } from '../../../components/table/beschreibung-table-wrapper.component';
import { ListLoaderWrapperComponent } from '../../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { KompaktStammpersonComponent } from '../../../kompaktdarstellung/stammperson/kompakt-stammperson.component';
import { KompaktPersonenadresseComponent } from '../../../kompaktdarstellung/personenadresse/kompakt-personenadresse.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipPersonstammPipe } from '../../../pipes/simple/tooltip-personstamm.pipe';
import { AppPermissionService } from '../../../../core/services/app-permission.service';
import { PermissionResponse } from '../../../../core/base-api';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-stammperson-table',
  templateUrl: './stammperson-table.component.html',
  styleUrls: ['./stammperson-table.component.scss'],
  imports: [
    BeschreibungTableWrapperComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    LinkComponent,
    KompaktStammpersonComponent,
    KompaktPersonenadresseComponent,
    TranslatePipe,
    TooltipPersonstammPipe
  ]
})
export class StammpersonTableComponent extends AbstractComponent {
  navTargets = NavTarget;

  listLoader: ListLoader<PersonStammMasterDetailEntryMeta>;

  liste: any;

  hasPermissionAuskunft: boolean = false;
  hasPermissionAdresse: boolean = false;

  @Input()
  title: string;

  @Input()
  tableFullWidth = true;

  constructor(private permissionService: AppPermissionService) {
    super();
    this.hasPermissionAuskunft = this.permissionService.hasPermission(PermissionsEnum.AUSKUNFTSPERRE);
    this.hasPermissionAdresse = this.permissionService.hasPermission(PermissionsEnum.ADRESSSPERRE);
  }

  @Input()
  set stammpersonen(value: Array<PersonStammMasterDetailEntryMeta>) {
    this.liste = value;
    this.listLoader = new ListLoaderPreloaded<PersonStammMasterDetailEntryMeta>(undefined, 1, value);
    super.addLoader(this.listLoader);
  }

  @Input()
  set stammpersonenListLoader(value: ListLoaderPreloaded<PersonStammMasterDetailEntryMeta>) {
    if (!value) {
      return;
    }
    this.listLoader = value;
    super.addLoader(this.listLoader);
  }

  showPersonendaten(auskunftsperre: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum): boolean {
    let hasAuskunftsperre = auskunftsperre === PersonStammMasterDetailEntryMeta.AuskunftsperreEnum.AUSKUNFT_SPERRE;
    return !hasAuskunftsperre || (hasAuskunftsperre && this.hasPermissionAuskunft);
  }

  showAdressen(auskunftsperre: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum): boolean {
    let hasAdresssperre = auskunftsperre === PersonStammMasterDetailEntryMeta.AuskunftsperreEnum.ADRESS_SPERRE;
    return !hasAdresssperre || (hasAdresssperre && this.hasPermissionAdresse);
  }
}
